import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from '@openng/optimus-ui/button';
import { ToolbarModule } from '@openng/optimus-ui/toolbar';
import { FileSizePipe } from '~ngx-shared/pipes';

@Component({
  selector: 'lib-file',
  imports: [ToolbarModule, ButtonModule, TranslocoDirective, FileSizePipe],
  templateUrl: './file.component.html',
  styleUrl: './file.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => FileComponent)
    }
  ]
})
export class FileComponent implements ControlValueAccessor {
  readonly accept = input<string | undefined>();
  readonly size = input<number | undefined>();

  readonly sizeLimit = 15 * 1024 * 1024;

  disabled = false;
  fileName: string;
  fileSize: number;

  private touched = false;

  fileSelected(files: FileList | null) {
    this.markAsTouched();
    const value = files?.item(0) ?? undefined;
    this.writeValue(value);
    this.onChange(value);
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  // Form methods

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Updates the label only; the form already holds this value.
  writeValue(value: File | null | undefined): void {
    this.fileName = value?.name ?? '';
    this.fileSize = value?.size ?? 0;
  }

  private onChange = (value: File | undefined) => {};

  private onTouched = () => {};
}
